const initialState = {
    smsHistory: [],
    from: [],
    history: [],
    isGettingSmsHistory: false,
}

export default initialState;
